import styled from '@emotion/styled'

import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'

const HorizontalRule = overrideOptional(styled.hr`
  border: 1px solid ${theme.gray500};
  margin: 1rem 0;
`)

export default HorizontalRule
